
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { RegisterUserDTO } from '../../lib/modules/auth/dtos/RegisterUserDTO'

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { User } from '../../lib/models/User'
import { CustomerRegister } from '../../lib/models/CustomerRegister'

@Component({
  components: {
    VuePhoneNumberInput
  }
})
export default class RegisterBaseData extends Vue {
  @Prop({ required: true }) user!: RegisterUserDTO

  phone: any = {};
  phoneNumberInputModel = ''; // needs to exist even when not used, does not work without a v-model even though you have to use the update event anyway, made a github issue about it: https://github.com/LouisMazel/vue-phone-number-input/issues/163

  @Watch('phone')
  public onPhoneChanged () {
    this.user.phone = this.phone.formatInternational
  }

  get customerReferrerTypes () {
    return User.customerReferrerTypes
  }

  get tShirtSizes () {
    return CustomerRegister.tshirtsizes
  }
}
